//Import all translation files
import bankEn from "./translation/en/bank.json"
import campaignEn from "./translation/en/campaign.json"
import changePasswordFormEn from "./translation/en/change-password-form.json"
import commonEn from "./translation/en/common.json"
import copyrightEn from "./translation/en/copyright.json"
import corporateEn from "./translation/en/corporate.json"
import dashboardEn from "./translation/en/dashboard.json"
import distinteEn from "./translation/en/distinte.json"
import faqEn from "./translation/en/faq.json"
import forgotPasswordFormEn from "./translation/en/forgot-password-form.json"
import loginFormEn from "./translation/en/login-form.json"
import logoutEn from "./translation/en/logout.json"
import otpEn from "./translation/en/otp-form.json"
import plickEn from "./translation/en/plick.json"
import reportEn from "./translation/en/report.json"
import sortEn from "./translation/en/sort.json"
import uploadEn from "./translation/en/upload.json"
import userMenuEn from "./translation/en/user-menu.json"
import userEn from "./translation/en/user.json"
import bankIt from "./translation/it/bank.json"
import campaignIt from "./translation/it/campaign.json"
import changePasswordFormIt from "./translation/it/change-password-form.json"
import commonIt from "./translation/it/common.json"
import copyrightIt from "./translation/it/copyright.json"
import corporateIt from "./translation/it/corporate.json"
import dashboardIt from "./translation/it/dashboard.json"
import distinteIt from "./translation/it/distinte.json"
import faqIt from "./translation/it/faq.json"
import forgotPasswordFormIt from "./translation/it/forgot-password-form.json"
import loginFormIt from "./translation/it/login-form.json"
import logoutIt from "./translation/it/logout.json"
import otpIt from "./translation/it/otp-form.json"
import plickIt from "./translation/it/plick.json"
import reportIt from "./translation/it/report.json"
import sortIt from "./translation/it/sort.json"
import uploadIt from "./translation/it/upload.json"
import userMenuIt from "./translation/it/user-menu.json"
import userIt from "./translation/it/user.json"

const resources = {
	en: {
		bank: bankEn,
		campaign: campaignEn,
		common: commonEn,
		changePasswordForm: changePasswordFormEn,
		copyright: copyrightEn,
		corporate: corporateEn,
		dashboard: dashboardEn,
		distinte: distinteEn,
		faq: faqEn,
		forgotPasswordForm: forgotPasswordFormEn,
		loginForm: loginFormEn,
		logout: logoutEn,
		otp: otpEn,
		plick: plickEn,
		report: reportEn,
		sort: sortEn,
		user: userEn,
		userMenu: userMenuEn,
		upload: uploadEn,
	},
	it: {
		bank: bankIt,
		campaign: campaignIt,
		common: commonIt,
		copyright: copyrightIt,
		corporate: corporateIt,
		dashboard: dashboardIt,
		faq: faqIt,
		forgotPasswordForm: forgotPasswordFormIt,
		loginForm: loginFormIt,
		changePasswordForm: changePasswordFormIt,
		distinte: distinteIt,
		logout: logoutIt,
		otp: otpIt,
		plick: plickIt,
		report: reportIt,
		sort: sortIt,
		user: userIt,
		userMenu: userMenuIt,
		upload: uploadIt,
	},
}
export default resources
